// @flow
export { default } from './MainTemplate';



// WEBPACK FOOTER //
// ./src/components/main/MainTemplate/index.js